// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZUY3znDqfD8Ovbke3rA3 {\n  display: flex;\n  flex-direction: row;\n}\n\n.tmjfVW2bdr11ZRJfcnBs {\n  margin: 0 5px;\n}\n\n.sBVVnsAIWbJfttsj4JrX {\n  display: flex;\n  flex-direction: column;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Search/Search.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n}\n\n.searchBar {\n  margin: 0 5px;\n}\n\n.suggestions {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ZUY3znDqfD8Ovbke3rA3",
	"searchBar": "tmjfVW2bdr11ZRJfcnBs",
	"suggestions": "sBVVnsAIWbJfttsj4JrX"
};
export default ___CSS_LOADER_EXPORT___;
